import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { getUserData } from '../../../../entity/user/model/selector/getUserData/getUserData'
import EditReference from '../EditReference/EditReference'
import DeleteReference from '../DeleteReference/DeleteReference'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

const InnerArticle = ({ articleId, reference, index }) => {
  const user = useSelector(getUserData, shallowEqual)
  const { i18n } = useTranslation()

  return (
    <>
      <Helmet>
        <meta charSet='utf-8' />
        <title>{reference?.description || 'Reference'}</title>
        <meta name='description' content={reference?.description} />
        <meta property='og:title' content={reference?.description || 'Reference'} />
        <meta property='og:description' content={reference?.description} />
        <meta property='og:type' content='article' />
        <meta property='og:url' content={`http://moambe.org.ge/volumes/${articleId}`} />
        <meta property='og:image' content={reference?.image} />
        <meta property='og:site_name' content='Moambe Journal / მოამბე ჟურნალი' />
        <meta property='twitter:card' content='summary_large_image' />
        <meta property='twitter:title' content={reference?.description || 'Reference'} />
        <meta property='twitter:description' content={reference?.description} />
        <meta name='description' lang='ka' content={reference?.description} />
        <meta property='og:description' lang='ka' content={reference?.description} />
      </Helmet>
      <div className='text-[#042A54] text-base' key={reference.id}>
        <span className='flex flex-row flex-wrap items-center gap-2'>
          <p className='mb-0 whitespace-pre-line break-words max-w-xs'>
            {index + 1}.&nbsp;
            {i18n.language === 'ka' ? reference?.description_ka : reference?.description}
          </p>
          {user?.role === 'admin' && (
            <div className='flex flex-row gap-1'>
              <EditReference articleId={articleId} reference={reference} data={reference} />
              <DeleteReference articleId={articleId} referenceId={reference?.id} />
            </div>
          )}
        </span>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href={reference?.doi_url}
          className='text-[#042A54] m-0'
        >
          <p className='hover:no-underline underline text-sm'>{reference?.doi_url}</p>
        </a>
      </div>
    </>
  )
}

export default InnerArticle
